import * as React from 'react';

export default ({ className = '' }: { className?: string }) => {
  return (
    <svg
      className={`${className} inline-block align-middle`}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      data-testid="arrow-left-icon"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20 12H4M4 12L10 18M4 12L10 6"
        stroke="currentColor"
        strokeWidth="strokeCurrent"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
